/*
 * -----------------------------------------------------------------------
 *  <copyright file="characters-remaining.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { useTranslation } from '@hooks/index';

import './characters-remaining.scss';

interface ICharactersRemainingProps {
    id: string;
    length?: number;
    max?: number;
    error?: null | string;
    customText?: string;
}

const CharactersRemaining = ({ id, length, max, error, customText }: ICharactersRemainingProps) => {
    const { t } = useTranslation();
    const remaining = max === undefined ? undefined : max - (length ?? 0);

    const text = customText ? (
        <span id={`${id}-remaining-text`} data-testid={`${id}-remaining-text`} className="remaining-text">
            {customText}
        </span>
    ) : remaining !== undefined ? (
        <span id={`${id}-remaining-text`} data-testid={`${id}-remaining-text`} className="remaining-text">
            {remaining} {t(remaining === 1 ? 'characterRemaining' : 'charactersRemaining')}
        </span>
    ) : null;

    return error ? (
        <span id={`${id}-error-text`} data-testid={`${id}-remaining-text`} className="remaining-text red">
            {error}
        </span>
    ) : length || max || customText ? (
        text
    ) : null;
};

export default CharactersRemaining;
